const countries = new Set([
    'united kingdom',
    'virgin islands, british',
    'british virgin islands',
    'isle of man',
    'british indian ocean territory',
    'cayman islands',
    'montserrat',
    'bermuda',
    'falkland islands',
    'gibraltar',
    'pitcairn islands',
    'turks and caicos islands',

    'switzerland',
    'liechtenstein',
    'norway',

    'austria',
    'belgium',
    'bulgaria',
    'croatia',
    'cyprus',
    'czech republic',
    'denmark',
    'estonia',
    'finland',
    'aland islands',
    'åland',
    'france',
    'french guiana',
    'french polynesia',
    'guadeloupe',
    'martinique',
    'reunion',
    'mayotte',
    'saint martin',
    'germany',
    'greece',
    'hungary',
    'ireland',
    'italy',
    'latvia',
    'lithuania',
    'luxembourg',
    'malta',
    'netherlands',
    'poland',
    'portugal',
    'romania',
    'slovakia',
    'slovenia',
    'spain',
    'sweden',

    'israel',
]);

export const shouldApplyGDPR = (country: string) => countries.has(country.toLowerCase());
